<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />
    

    <div class="solicitacao-layout">
        <div class="solicitacao-info">
            <div class="form-edit-page">
                <div class="row row-space">
                    <div class="form-item-codigo">
                        <label class="label-caption">Nro OS</label>
                        <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.cdipos) }}</div>
                    </div>

                    <div class="form-item-data">
                        <label class="label-caption">Data</label>
                        <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtipos) }}</div>
                    </div>

                    <div class="form-item">
                        <label class="label-caption">Bairro</label>
                        <div class="field-label">{{ objView.nmbairro }}</div>
                    </div>

                    <div class="form-item ">
                        <label class="label-caption">Logradouro</label>
                        <div class="field-label">{{ objView.nmlogradouro }}</div>
                    </div>

                    <div class="form-item" style="flex: 0 0 90px;">
                        <label class="label-caption">Nro</label>
                        <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.nmendereco) }}</div>
                    </div>
                </div>

                

                <div v-if="objViewSolicitacao" class="row row-space">
                    <div class="form-item-codigo">
                        <label class="label-caption">Solicitação</label>
                        <div class="field-label field-label-end">{{ Funcoes.formatInteger(objViewSolicitacao.cdipossolicitacao) }}</div>
                    </div>
                    <div class="form-item">
                        <label class="label-caption">Nome Solicitante</label>
                        <div class="field-label">{{ objViewSolicitacao.nmpessoa }}</div>
                    </div>
                    <div class="form-item-fone">
                        <label class="label-caption">Fone</label>
                        <div class="field-label">{{ objViewSolicitacao.fone }}</div>
                    </div>
                    <div class="form-item-data">
                        <label class="label-caption">Data</label>
                        <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objViewSolicitacao.dtsolicitacao) }}</div>
                    </div>
                </div>


                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">Referência</label>
                        <div class="field-label">{{ objView.referencia }}</div>
                    </div>

                    <div class="form-item-char30">
                        <label class="label-caption">Coordenadas</label>
                        <div class="field-label field-label-center">{{ objView.latitude }} x {{ objView.longitude }}</div>
                    </div>
                </div>


                <div class="row row-space">
                    <div class="form-item" style="flex: 0 0 90px;">
                        <label class="label-caption">Cód. Prest.</label>
                        <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.idipprestador) }}</div>
                    </div>

                    <div class="form-item">
                        <label class="label-caption">Prestador do Serviço</label>
                        <div class="field-label">{{ objView.nmfornecedor }}</div>
                    </div>

                    <div class="form-item" style="flex: 0 0 220px;">
                        <label class="label-caption">Situação</label>
                        <div class="field-label field-label-center">{{ objView.statusnm }}</div>
                    </div>
                </div>


                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">Data/Hora Autorização</label>
                        <div class="field-label">{{ Funcoes.formatDateTimeFromJson(objView.dhautorizacao) }}</div>
                    </div>

                    <div class="form-item form-item-data">
                        <label class="label-caption">Data Início</label>
                        <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtinicio) }}</div>
                    </div>

                    <div class="form-item form-item-data">
                        <label class="label-caption">Hora</label>
                        <div class="field-label field-label-center">{{ objView.hrinicio }}</div>
                    </div>

                    <div class="form-item form-item-data">
                        <label class="label-caption">Data Fim</label>
                        <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtfim) }}</div>
                    </div>

                    <div class="form-item form-item-data">
                        <label class="label-caption">Hora</label>
                        <div class="field-label field-label-center">{{ objView.hrfim }}</div>
                    </div>

                    <div class="form-item form-item-data">
                        <label class="label-caption">Quantidade</label>
                        <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.qtd_itens) }}</div>
                    </div>

                    <div class="form-item form-item-data">
                        <label class="label-caption">Total</label>
                        <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.vltotal) }}</div>
                    </div>
                </div>


                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">Detalhamento</label>
                        <div class="field-label">{{ objView.detalhamento }}</div>
                    </div>            
                </div>


                <div class="row-end">
                    <button v-if="ckAutorizacao" type="button" @click="autorizarExecucao">Autorizar</button>
                    <button type="button" @click="imprimir">Imprimir</button>
                    <button type="button" @click="closeForm">Retornar</button>
                </div>
            </div>
            

            <div v-if="showMap" class="form-edit-page margin-top10">
                <MapComponent :latitude="objView.latitude" :longitude="objView.longitude" />
            </div>
        </div>
        
        
        <div v-if="imageSrc" class="solicitacao-foto">
            <div class="form-edit-page foto-card">
                <img :src="imageSrc" alt="Imagem carregada" @click="showModalImage = true" />
            </div>
        </div>
    </div>


    <div>
        <ImageModal v-if="showModalImage" :imageSrc="imageSrc" :visible="showModalImage" @close="showModalImage=false" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import ImageModal from '@/components/modals/ImageModal.vue';
import MapComponent from '@/components/MapComponent.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({
    idView: {type: Number, default: 0},
    ckAutorizacao: {type: Boolean, default: false}});

const errorMessage = ref(null);
const imageSrc = ref(null);
const isLoading = ref(false);
const objView = ref({});
const objViewSolicitacao = ref({});
const showMap = ref(false);
const showModalImage = ref(false);


function closeForm() {
    emit('close');
}


const autorizarExecucao = async() => {
    try{
        isLoading.value=true;
        const r = await Api.genericPut('/cad/ipos', {
            id: objView.value.id,
            dhautorizacao: Funcoes.strDataHoraAtual(),
            lgautorizacao: globalStore.idlogin});
        if (r.bolok === 1){
            emit('save');
            emit('close');
        }else{errorMessage.value = `ATENÇÃO: ${r.error}`;}
    } catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


const imprimir = async() => {
    try{
        isLoading.value = true;
        const dados = {
            nmrelatorio: 'ipos_emissao',
            id: objView.value.id,
            idmunicipio: globalStore.idmunicipio,
            idusuario: globalStore.idusuario};
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } finally {isLoading.value = false;}
}


const lerDados = async() => {
    try{
        isLoading.value = true;
        const req = await Api.genericPost('/ip/ipos/full', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        Object.assign(objView.value, req[0]);
        showMap.value = ((objView.value) && (objView.value.latitude) && (objView.value.longitude));


        // BUSCA DADOS DA SOLICITAÇÃO PARA BAIXAR IMAGEM ANEXADA
        const reqSol = await Api.genericPost('/ip/ipossolicitacoes', {idmunicipio: globalStore.idmunicipio, intparam2: objView.value.id});
        if (reqSol.length>0){
            Object.assign(objViewSolicitacao.value, reqSol[0]);

            // LISTA DE ANEXOS  --  MOSTRANDO APENAS O PRIMEIRO
            const lsImagens = await Api.genericPost('/ip/ipossolicitacoes/anexos', {idmunicipio: globalStore.idmunicipio, id: reqSol[0].id});
            if (lsImagens.length > 0){
                
                if (lsImagens[0].storage_cdtipo === 2){
                    const rUrl = await Api.genericPost('/main/solicitar/download', {id: lsImagens[0].idanexo});
                    if (rUrl.bolok === 1){
                        imageSrc.value = rUrl.download_url;
                    }else{
                        console.log(rUrl);
                    }
                }else{
                    const reqFoto = await Api.genericGet('/main/anexo_view_base64', {id: lsImagens[0].idanexo});
                    if (reqFoto){
                        imageSrc.value = `data:image/jpeg;base64,${reqFoto.anexo}`;
                    }
                }
            }
        }
    }catch (error){alert(error);
    }finally{isLoading.value = false;}
}


onMounted(lerDados);
</script>

<style scoped>
.solicitacao-layout {
    display: grid;
    grid-template-columns: minmax(520px, 1fr) minmax(280px, 360px);
    gap: 14px;
    align-items: start;
}

.solicitacao-foto {
    min-width: 0;
}

.foto-card {
    padding: 8px;
}

.solicitacao-foto img {
    width: 100%;
    height: calc(100vh - 220px);
    min-height: 420px;
    object-fit: contain;
    border-radius: 8px;
    cursor: pointer;
    background: #f8fafc;
}

.solicitacao-info {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
}

.map-card {
    border: 1px solid #d8dee9;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    min-height: 320px;
}

.map-card :deep(.leaflet-container),
.map-card :deep(.map-container),
.map-card :deep(#map) {
    width: 100%;
    height: 320px;
}

@media (max-width: 1100px) {
    .solicitacao-layout {
        grid-template-columns: 1fr;
    }

    .solicitacao-info {
        order: 1;
    }

    .solicitacao-foto {
        order: 2;
    }

    .solicitacao-foto img {
        height: auto;
        min-height: unset;
        max-height: 520px;
    }
}
</style>